import { VerificationDTO } from 'src/common/models/verificationModels';
import { PublicAspspItemDTO } from 'src/pages/AspspSelectPage/aspspModels';

export enum ActionType {
  SetProcessData = 'SetProcessData',
  SelectAspsp = 'SelectAspsp',
  SetUserReturningToProcess = 'SetUserReturningToProcess',
  RedirectToScreenScrape = 'RedirectToScreenScrape',
  OpenScreenScrape = 'OpenScreenScrape',
  CloseScreenScrape = 'CloseScreenScrape',
}

interface State {
  selectedAspsp?: PublicAspspItemDTO;
  processData?: VerificationDTO;
  isUserReturningToProcess: boolean;
  isScreenScrapeModalOpen: boolean;
}

type RequiredState = Required<State>;

type Action =
  | {
      type: ActionType.SetProcessData;
      payload: RequiredState['processData'];
    }
  | {
      type: ActionType.SelectAspsp;
      payload: RequiredState['selectedAspsp'];
    }
  | {
      type: ActionType.SetUserReturningToProcess;
    }
  | {
      type: ActionType.RedirectToScreenScrape;
      payload: Pick<
        RequiredState,
        'isScreenScrapeModalOpen' | 'processData' | 'selectedAspsp'
      >;
    }
  | {
      type: ActionType.OpenScreenScrape;
    }
  | {
      type: ActionType.CloseScreenScrape;
    };

export const initialAspspState = {
  selectedAspsp: undefined,
  processData: undefined,
  isUserReturningToProcess: false,
  isScreenScrapeModalOpen: false,
};

export const aspspReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SetProcessData:
      return {
        ...state,
        processData: action.payload,
      };
    case ActionType.SetUserReturningToProcess:
      return {
        ...state,
        isUserReturningToProcess: true,
      };
    case ActionType.SelectAspsp:
      return {
        ...state,
        selectedAspsp: action.payload,
      };
    case ActionType.RedirectToScreenScrape:
      return {
        ...state,
        ...action.payload,
      };
    case ActionType.OpenScreenScrape:
      return {
        ...state,
        isScreenScrapeModalOpen: true,
      };
    case ActionType.CloseScreenScrape:
      return initialAspspState;
    default:
      return state;
  }
};
